import React, { useContext } from "react";
import { CircularProgress } from "@material-ui/core";
import { get } from "lodash";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import { PAGE_ERROR } from "../../constants/MediaSearch";
import { PageErrorContent } from "../page-error/PageError";
import { ReactComponent as Info } from "../../assets/icons/information.svg";
import "./table.scss";
import MediaRequestEpisodeAccordions from "./MediaRequestEpisodeAccordions";

const MediaRequestTable = () => {
  const { assetData, selectedOption, fetchAssets, recordType } =
    useContext(MediaRequestContext);
  const selectedOptionLabel = get(selectedOption, "payload.title", "");

  const errorPage = (callback) => (
    <div className="media-search-table-header media-error-container">
      <PageErrorContent
        title={PAGE_ERROR.title}
        message={PAGE_ERROR.message}
        reloadBtn={true}
        onReloadClick={callback}
      />
    </div>
  );

  const noResultsMessage = (message) => (
    <p className="media-no-result-paragraph">
      <Info className="media-info-icon" /> {message}.
    </p>
  );

  const MediaAssetWrapper = ({ children }) => (
    <div className="media-asset">{children}</div>
  );

  return (
    <div className="media-results">
      {assetData === "loading" && (
        <MediaAssetWrapper>
          <CircularProgress size={35} />
        </MediaAssetWrapper>
      )}
      {assetData === "error" && (
        <MediaAssetWrapper>
          {" "}
          {errorPage(() => fetchAssets(selectedOption))}{" "}
        </MediaAssetWrapper>
      )}
      {assetData === "idsError" && (
        <MediaAssetWrapper>
          <div className="media-search-table-header media-id-type-error-container">
            <PageErrorContent
              title={PAGE_ERROR.title}
              message={PAGE_ERROR.message}
              reloadBtn={false}
            />
          </div>
        </MediaAssetWrapper>
      )}
      {typeof assetData !== "string" && !assetData.length ? (
        <MediaAssetWrapper>
          {noResultsMessage(
            recordType === "idType"
              ? "No results found for the searched IDs"
              : `No result found for the selected asset: ${selectedOptionLabel}`
          )}
        </MediaAssetWrapper>
      ) : null}
      {typeof assetData !== "string" && assetData.length
        ? assetData.map(({ asset }, index) => (
            <MediaRequestEpisodeAccordions
              key={`episode-${index}`}
              asset={asset}
              assetIndex={index}
            />
          ))
        : null}
    </div>
  );
};

export default MediaRequestTable;
